import { render, staticRenderFns } from "./GAuthTextarea.vue?vue&type=template&id=6702f0f2&scoped=true&"
import script from "./GAuthTextarea.vue?vue&type=script&lang=ts&"
export * from "./GAuthTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./GAuthTextarea.vue?vue&type=style&index=0&id=6702f0f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6702f0f2",
  null
  
)

export default component.exports